/**
 * Query Key factory for all follow-up queries.
 *
 * @module FollowUp
 */

import { Pagination } from "@customTypes/index";


export const followUpQKeys = {
  all: () => ["followUp"] as const,

  allWithFilters: (filters?: {
    pagination?: Partial<Pagination>;
    search?: string;
    doctor?: string;
  }) => [...followUpQKeys.all(), { ...filters }] as const,

  // singlePatients: () => [...followUpQKeys.all(), "singlePatient"] as const,

  // singlePatient: (patientId: string) =>
  //   [...followUpQKeys.singlePatients(), patientId] as const,
};
